import React, { useReducer, createContext, } from 'react';

export const StationContext = createContext('');

const initialState = {
    station: {},
    pendingQueue: [],
    loading: false, 
    error: null,
};

const reducer = (state, action) => {
    let devicesArr; 
    let pendingChangesArr;
    let vlanTagsArr;
    let macDevicesArr;

    switch(action.type) {
        case 'SET_STATION':
            return {
                ...state,
                station: action.payload,
            };
        case 'UPDATE_STATION_INFORMATION': 
            return {
                ...state,
                station: ({...state.station, ...action.payload})
            }
        case 'ADD_DEVICE':
            state.station.Devices ??= []
            devicesArr = [...state.station.Devices, {...action.payload}] 
            return {
                ...state,
                station: ({...state.station, Devices: devicesArr})
            };
        case 'UPDATE_DEVICE': {
            const pendingIndex = state.pendingQueue?.findIndex(pendingItem => pendingItem.id === action.payload);
            if (pendingIndex > -1){
                devicesArr = state.station.Devices.map((device) => (device.id === action.payload) ? state.pendingQueue[pendingIndex] : device)
                pendingChangesArr = state.pendingQueue?.filter(pending => pending.id !== action.payload);
                return {
                    ...state, 
                    station: ({...state.station, Devices: devicesArr }),
                    pendingQueue: pendingChangesArr,
                }
            } else {
                return {
                    ...state
                }
            }
        }
        case 'REMOVE_SUBSCRIBER_UNIT': {
            const newSubsUnitsArray = action.payload.SubscriberUnits?.filter(subUnit => !subUnit?.deleted);
            devicesArr = state.station.Devices?.map((device) => 
                device.id === action.payload?.id ? Object.assign(device, {SubscriberUnits: newSubsUnitsArray}) : device
            )

            return {
                ...state, 
                station: ({...state.station, Devices: devicesArr }),
            }
        }
        case 'UPDATE_SERIAL_NUMBER': {
            const deviceIndex = state.station.Devices?.findIndex(device => device.id === action.payload.id);
            const pendingIndex = state.pendingQueue?.findIndex(pendingItem => pendingItem.id === action.payload.id);

            if(deviceIndex > -1){
                devicesArr = state.station.Devices.map((device) => (device.id === action.payload.id) ? Object.assign(device, {serialNum: action.payload.newSerialNum}) : device)
                if(pendingIndex > -1 ) {
                    pendingChangesArr = state.pendingQueue?.map((pending) => (pending.id === action.payload.id) ? Object.assign(pending, {serialNum: action.payload.newSerialNum}) : pending)
                } else {
                    pendingChangesArr = state.pendingQueue;
                } 
            }

            return {
                ...state, 
                station: ({...state.station, Devices: devicesArr }),
                pendingQueue: pendingChangesArr
            }
        }
        case 'DELETE_DEVICE': 
            devicesArr = state.station.Devices.filter(device => device.id !== action.payload);
            return {
                ...state,
                station: ({...state.station, Devices: devicesArr})
            };
        case 'ADD_PENDING_QUEUE':
            const pendingIndex = state.pendingQueue?.findIndex(pendingItem => pendingItem.id === action.payload.id);
            let pendingItem = {
                id: action.payload.id, 
                deviceType: action.payload.deviceType, 
                ...action.payload,
            }
            if (pendingIndex > -1){
                pendingChangesArr = state.pendingQueue?.filter(pending => pending.id !== action.payload.id);
                return {
                    ...state, 
                    pendingQueue: [...pendingChangesArr, pendingItem],
                }
            } else {
                return {
                    ...state, 
                    pendingQueue: ([...state.pendingQueue, pendingItem]),
                }
            }
        case 'REMOVE_PENDING_CHANGE':
            pendingChangesArr = state.pendingQueue?.filter(pending => pending.id !== action.payload);
            return {
                ...state, 
                pendingQueue: pendingChangesArr,
            }
        case 'CLEAR_PENDING_QUEUE':
            return {
                ...state, 
                pendingQueue: [],
            }
        case 'ADD_VLAN_TAG': 
            vlanTagsArr = [...state.station.VLANTags, {...action.payload}] 
            return {
                ...state,
                station: ({...state.station, VLANTags: vlanTagsArr})
            };
        case 'DELETE_VLAN_TAG': 
            vlanTagsArr = state.station.VLANTags.filter(tag => tag.id !== action.payload);
            return {
                ...state, 
                station: ({...state.station, VLANTags: vlanTagsArr}),
            }
        case 'UPDATE_VLAN_TAG':
            let tagIndex = state.station.VLANTags.findIndex((tag) => tag.id === action.payload.id);
            if(tagIndex > -1){
                vlanTagsArr = state.station.VLANTags.map((tag) => (tag.id === action.payload.id) ? action.payload : tag);
                return {
                    ...state,
                    station: ({...state.station, VLANTags: vlanTagsArr}),
                }
            }
            return 
        case 'UPDATE_MAC_DEVICE': {
            const pendingIndex = state.pendingQueue?.findIndex(pendingItem => pendingItem.id === action.payload);
            if (pendingIndex > -1){
                macDevicesArr = state.station.Macdevices.map((macdevice) => (macdevice.id === action.payload) ? state.pendingQueue[pendingIndex] : macdevice)
                pendingChangesArr = state.pendingQueue?.filter(pending => pending.id !== action.payload);
                return {
                    ...state, 
                    station: ({...state.station, Macdevices: macDevicesArr }),
                    pendingQueue: pendingChangesArr,
                }
            } else {
                return {
                    ...state
                }
            }
        }
        case 'START': 
            return {
                ...state,
                loading: true
            };
        
        default: 
            throw new Error();
    }
};

export const StationContextProvider = props => {
    
    const [state, dispatch] = useReducer(reducer, initialState);

    return(
        <StationContext.Provider value={[state, dispatch]}>
            {props.children}
        </StationContext.Provider>
    )
}
